import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { forwardRef } from 'react';

const Iframe = styled.iframe`
  height: 100vh;
  width: 100%;
  border: none;
`;

const Calculator = forwardRef((props, ref) => {
  const { isScientific, className, version = 'v7' } = props;

  return (
    <Iframe
      ref={ref}
      className={className}
      title="calc"
      src={`https://quark.uacdn.net/calculator_${version}/Calc/${
        isScientific ? 'scientific' : 'normal'
      }.html`}
    />
  );
});

Calculator.displayName = 'Calculator';

export default Calculator;

Calculator.propTypes = {
  isScientific: PropTypes.bool,
  className: PropTypes.string
};

Calculator.defaultProps = {
  isScientific: false,
  className: ''
};
